<template>
  <div class="bg-gray-50 min-h-screen">
    <!-- 面包屑导航 -->
    <section class="bg-white border-b">
      <div class="container mx-auto px-6 py-4">
        <nav class="text-sm text-gray-600 flex items-center">
          <router-link to="/" class="hover:text-primary transition-colors">Home</router-link>
          <i class="fa fa-angle-right mx-2 text-gray-400"></i>
          <router-link to="/products" class="hover:text-primary transition-colors">Products</router-link>
          <i class="fa fa-angle-right mx-2 text-gray-400"></i>
          <span class="text-primary">{{ productDetail.name }}</span>
        </nav>
      </div>
    </section>

    <!-- 商品详情主内容 -->
    <section class="py-12">
      <div class="container mx-auto px-6">
        <!-- 商品标题与核心标签 -->
        <div class="mb-10 text-center">
          
          <h1 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            {{ productDetail.name }}
          </h1>
          <p class="text-gray-600 max-w-3xl mx-auto">
           {{ productDetail.application }}
          </p>
          <!-- <div class="mt-6 flex justify-center items-center gap-4">
            <span class="text-2xl font-bold text-primary">$2.49/roll</span>
            <span class="text-gray-500 line-through">Original: $3.29/roll</span>
            <span class="bg-red-500 text-white text-xs px-2 py-1 rounded">24% OFF</span>
          </div> -->
        </div>

        <!-- 商品图片与参数区（统一高度） -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          <!-- 商品图片（点击小图切换大图 + 放大尺寸） -->
          <div class="bg-white p-6 rounded-lg shadow-md flex flex-col h-full">
            <!-- 大图展示区（放大高度，占满容器） -->
            <div class="relative h-[400px] md:h-[500px] mb-4 overflow-hidden rounded-md bg-gray-50 flex items-center justify-center">
              <img 
                :src="currentMainImage" 
                alt="N809 Wax General Thermal Transfer Ribbon" 
                class="w-full h-full object-contain"
              >
            </div>
            <!-- 缩略图列表（点击切换大图） -->
            <div class="grid grid-cols-4 gap-2 mt-auto">  <!-- mt-auto 让缩略图靠下，填充空白 -->
              <div 
                class="h-24 bg-gray-100 rounded-md overflow-hidden cursor-pointer hover:ring-2 hover:ring-primary"
                :class="{ 'ring-2 ring-primary': currentMainImage == item }"
                @click="switchImage(0, item)"
                v-for="(item,index) in productDetail.imagesUrl" :key="index"
              >
                <img :src="item" alt="Product thumbnail 1" class="w-full h-full object-cover">
              </div>
            </div>
          </div>

          <!-- 商品参数展示区（与左侧高度对齐） -->
          <div class="bg-white p-8 rounded-lg shadow-md">
            <h2 class="text-xl font-semibold text-gray-800 mb-6">Product Specifications</h2>
            
            <!-- 规格展示 -->
            <div class="mb-6">
              <label class="block text-gray-700 mb-3 font-medium">Available Sizes：</label>
              <div class="flex flex-wrap gap-3">
                <span class=" text-gray-700">
                  {{ productDetail.specs}}
                </span>
              </div>
            </div>

            <!-- 材质展示 -->
            <div class="mb-6">
              <label class="block text-gray-700 mb-3 font-medium">Material Composition</label>
              <ul class="space-y-2 text-gray-600">
                <li class="flex items-center">
                  <i class="fa fa-check text-primary mr-2"></i>
                  <span>{{ productDetail.material}}</span>
                </li>
                <!-- <li class="flex items-center">
                  <i class="fa fa-check text-primary mr-2"></i>
                  <span>Colorant: Carbon Black</span>
                </li> -->
              </ul>
            </div>

            <!-- 颜色展示 -->
            <div class="mb-6">
              <label class="block text-gray-700 mb-3 font-medium">Available Colors：</label>
              <div class="flex gap-4 flex-wrap">
                <div class="flex flex-col items-center">
                  <span class="text-gray-600">{{ productDetail.color}}</span>
                </div>
              </div>
            </div>

            <!-- 产地信息 -->
            <div class="mb-6">
              <label class="block text-gray-700 mb-3 font-medium">Origin</label>
              <div class="flex items-center text-gray-600">
                <i class="fa fa-map-marker text-primary mr-2"></i>
                <span>{{ productDetail.origin}}</span>
              </div>
            </div>

            <!-- 分享功能区域（使用你提供的样式） -->
            <div class="mb-8 pt-6 border-t border-gray-200">
              <label class="block text-gray-700 mb-3 font-medium">Share This Product</label>
              <div class="flex gap-3">
                <!-- Facebook分享 -->
                <a 
                  href="#" 
                  class="w-9 h-9 rounded-full bg-[#1877F2] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                  @click.prevent="shareToFacebook()"
                >
                  <i class="fa fa-facebook"></i>
                </a>
                <!-- Twitter分享 -->
                <a 
                  href="#" 
                  class="w-9 h-9 rounded-full bg-[#1DA1F2] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                  @click.prevent="shareToTwitter()"
                >
                  <i class="fa fa-twitter"></i>
                </a>
                <!-- LinkedIn分享 -->
                <!-- <a 
                  href="#" 
                  class="w-9 h-9 rounded-full bg-[#0A66C2] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                  @click.prevent="shareToLinkedIn()"
                >
                  <i class="fa fa-linkedin"></i>
                </a> -->
                <!-- Pinterest分享 -->
                <!-- <a 
                  href="#" 
                  class="w-9 h-9 rounded-full bg-[#E60023] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                  @click.prevent="shareToPinterest()"
                >
                  <i class="fa fa-pinterest"></i>
                </a> -->
                <!-- 复制链接 -->
                <a 
                  href="#" 
                  class="w-9 h-9 rounded-full bg-gray-700 flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                  @click.prevent="copyLink()"
                >
                  <i class="fa fa-link"></i>
                </a>
              </div>
            </div>

            <!-- 物流与售后信息 -->
            <div class="mt-4 pt-6 border-t border-gray-200">
              <ul class="space-y-3 text-sm text-gray-600">
                <li class="flex items-start">
                  <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                  <span>Two days production, seven days shipping (the fastest in China)</span>
                </li>
                <li class="flex items-start">
                  <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                  <span>100% quality inspection before shipment</span>
                </li>
                <li class="flex items-start">
                  <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                  <span>30-day free return for quality issues</span>
                </li>
                <li class="flex items-start">
                  <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                  <span>24/7 technical support via email & WhatsApp</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 商品详情标签页 -->
        <div class="bg-white rounded-lg shadow-md mb-16">
          <div class="border-b">
            <div class="flex flex-wrap">
              <button class="px-6 py-4 font-medium text-primary border-b-2 border-primary">
                Product Details
              </button>
            </div>
          </div>

          <!-- 商品详情内容 -->
          <div class="p-8">
            <div class="" v-html="productDetail.content">
              
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 提示消息弹窗 -->
    <teleport to="body">
      <div v-if="showToast" class="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-6 py-3 rounded-full shadow-lg z-50 flex items-center">
        <i :class="toastIcon" class="mr-2"></i>
        <span>{{ toastMessage }}</span>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getProductDetail } from '@/api/product'
// 获取当前路由参数（实际项目中可通过API根据ID获取数据）
const route = useRoute()
const productId = ref(route.params.productId)
console.log(productId.value)
onMounted(() => {
  getProductDetailData()
})
const productDetail = ref({})


// 图片切换逻辑
const currentMainImage = ref('') // 默认大图
const currentThumbIndex = ref(0) // 当前选中的缩略图索引

// 分享相关状态
const showToast = ref(false)
const toastMessage = ref('')
const toastIcon = ref('')

// 切换大图：参数1=缩略图索引，参数2=大图地址
const switchImage = (index, imageUrl) => {
  currentMainImage.value = imageUrl
  currentThumbIndex.value = index
}
const getProductDetailData = async () => {
  try {
    // 调用接口，传入新闻 ID
    const res = await getProductDetail(productId.value)
    productDetail.value = res.data // 假设接口返回的详情数据在 res.data 中
    currentMainImage.value = productDetail.value.imagesUrl[0]
    console.log(productDetail.value)
  } catch (error) {
    console.error('获取详情失败：', error)
  }
}
// 显示提示消息
const showNotification = (message, icon) => {
  toastMessage.value = message
  toastIcon.value = icon
  showToast.value = true
  setTimeout(() => {
    showToast.value = false
  }, 2000)
}

// 分享到Facebook
const shareToFacebook = () => {
  const shareUrl = window.location.href
  const title = productDetail.value.name
  // const description = 'Economical wax ribbon with excellent label adaptability and high printing clarity'
  
  // Facebook官方分享链接
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`
  
  // 打开Facebook分享窗口
  window.open(facebookShareUrl, '_blank', 'width=600,height=400')
  showNotification('Opening Facebook share window...', 'fa fa-external-link text-blue-300')
}

// 分享到Twitter
const shareToTwitter = () => {
  const shareUrl = window.location.href
  const title = productDetail.value.name
  const hashtags = 'ThermalTransferRibbon,LabelPrinting,BarcodeRibbon'
  
  // Twitter官方分享链接
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}&hashtags=${encodeURIComponent(hashtags)}`
  
  // 打开Twitter分享窗口
  window.open(twitterShareUrl, '_blank', 'width=600,height=400')
  showNotification('Opening Twitter share window...', 'fa fa-external-link text-blue-300')
}

// 分享到LinkedIn
// const shareToLinkedIn = () => {
//   const shareUrl = window.location.href
//   const title = productDetail.value.name
//   const summary = 'Economical wax ribbon with excellent label adaptability and high printing clarity - 24% discount now!'

//   const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}`
//   window.open(linkedInShareUrl, '_blank', 'width=600,height=400')
//   showNotification('Opening LinkedIn share window...', 'fa fa-external-link text-blue-300')
// }

// 分享到Pinterest
// const shareToPinterest = () => {
//   const shareUrl = window.location.href
//   const title =  productDetail.value.name
//   const media = productDetail.value.imagesUrl[0]// 分享当前显示的商品图片

//   const pinterestShareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(media)}&description=${encodeURIComponent(title)}`

//   window.open(pinterestShareUrl, '_blank', 'width=600,height=600')
//   showNotification('Opening Pinterest share window...', 'fa fa-external-link text-red-300')
// }

// 复制产品链接
const copyLink = () => {
  const productUrl = window.location.href
  
  // 复制到剪贴板
  navigator.clipboard.writeText(productUrl)
    .then(() => {
      showNotification('Product link copied successfully!', 'fa fa-check-circle text-green-400')
    })
    .catch(err => {
      console.error('Failed to copy link:', err)
      showNotification('Failed to copy link', 'fa fa-exclamation-circle text-red-400')
    })
}
</script>

<style scoped>
/* 图片区域样式优化 */
.relative.h-\[400px\], .relative.h-\[500px\] {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 缩略图：增加高度，提升点击区域 */
.h-24 {
  overflow: hidden;
  transition: all 0.3s ease;
}
.h-24 img {
  transition: transform 0.3s ease;
}
.h-24:hover img {
  transform: scale(1.1);
}
/* 选中的缩略图：高亮边框 */
.ring-2.ring-primary {
  border-color: var(--tw-ring-color);
  box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.2);
}

/* 标签页样式优化 */
button.active {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}
button:not(.active):hover {
  color: var(--primary);
}

/* 规格/颜色展示样式优化 */
.flex-wrap.gap-3 > span {
  transition: all 0.2s ease;
}
.flex-wrap.gap-3 > span:hover {
  border-color: var(--primary);
  color: var(--primary);
}

/* 分享按钮额外样式优化 */
.w-9.h-9.rounded-full {
  transition: all 0.2s ease;
  transform: translateY(0);
}
.w-9.h-9.rounded-full:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

/* 提示消息动画 */
.v-enter-from {
  opacity: 0;
  transform: translate(-50%, 20px);
}
.v-enter-active {
  transition: all 0.3s ease;
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 20px);
}
.v-leave-active {
  transition: all 0.3s ease;
}
</style>